<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="max-w-md w-full mx-auto text-center px-4">
      <div class="mb-8">
        <!-- 401 Icon -->
        <div class="mx-auto w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6">
          <svg class="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>

        <!-- Error Code -->
        <h1 class="text-6xl font-bold text-text-primary mb-4">401</h1>

        <!-- Error Title -->
        <h2 class="text-2xl font-semibold text-text-primary mb-4">Authentication Required</h2>

        <!-- Error Description -->
        <p class="text-text-secondary mb-8">
          You need to be logged in to access this page. Please log in with your credentials to continue.
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-4">
        <router-link
            to="/login"
            class="block w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Login Now
        </router-link>

        <router-link
            to="/register"
            class="block w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Create Account
        </router-link>

        <button
            @click="goBack"
            class="w-full bg-background-light hover:bg-background-lighter text-text-primary font-medium py-3 px-6 rounded-md border border-background-lighter transition-colors"
        >
          Go Back
        </button>
      </div>

      <!-- Additional Help -->
      <div class="mt-8 pt-8 border-t border-background-lighter">
        <p class="text-sm text-text-secondary mb-4">Need help accessing your account?</p>
        <div class="flex justify-center space-x-6 text-sm">
          <router-link to="/contact" class="text-primary hover:underline">Contact Support</router-link>
          <router-link to="/faq" class="text-primary hover:underline">FAQ</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  },
  mounted() {
    document.title = '401 - Authentication Required | Eskrag';
  }
}
</script>
